import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/bookings/')({
  component: BookingsIndexPage,
});

// The Requests / Needs triage index is table-only. The parent layout renders the
// table for the bare index route (desktop) and the list panel on mobile, so this
// leaf route has nothing to render. It previously auto-redirected to the first
// request's detail to fill the split view's right pane — that behaviour is gone
// with the split view, and it must NOT bounce a fresh landing (no stored view
// preference) away from the table.
function BookingsIndexPage() {
  return null;
}
